import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => {
    const unit = theme.spacing();
    return {
        root: {
            flex: '1 1 auto',
            overflowY: 'auto',
        },
        normal: {
            padding: `${2 * unit}px ${3 * unit}px`,
        },
        tiny: {
            padding: 0,
        },
    };
};

const BoxContent = ({ classes, className, text, tiny, children }) => {
    const boxClassName = classNames(
        classes.root,
        tiny ? null : classes.normal,
        className
    );
    return (
        <div className={boxClassName}>
            {text ? (
                <Typography
                    component="p"
                    variant="subtitle1"
                    color="textSecondary"
                >
                    {children}
                </Typography>
            ) : (
                children
            )}
        </div>
    );
};

BoxContent.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    text: PropTypes.bool,
};

BoxContent.defaultProps = {
    text: false,
    tiny: false,
};

export default withStyles(styles)(BoxContent);
